import styles from "./Spinner.module.css";

export function Spinner({ label = "Loading" }) {
  return (
    <div className={styles.wrapper} role="status">
      <div className={styles.spinner} />
      <span className="visually-hidden">{label}</span>
    </div>
  );
}
